/*
 Helper functions mostly intended for replacing jQuery functions
 http://youmightnotneedjquery.com/
*/

export function documentReady(fn) {
  if (
    document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"
  ) {
    fn()
  } else {
    document.addEventListener("DOMContentLoaded", fn)
  }
}
